var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipLactoseFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 8.46V7.98H10.58V8.46C10.58 8.46 10.58 8.56 10.58 8.62H13.43C13.43 8.57 13.43 8.51 13.43 8.46H13.42Z",
    fill: "#66CFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.74 11.03C13.27 10.91 13.16 11.23 11.85 11.45C11.55 11.5 11.02 11.32 10.57 11.27C10.26 11.23 10 11.45 10 11.77V16.02C10 16.27 10.17 16.46 10.39 16.46H13.63C13.84 16.46 14.01 16.26 14.01 16.02V11.51C14.01 11.28 13.96 11.09 13.75 11.03H13.74Z",
    fill: "#66CFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM17.75 17.75C16.61 18.89 15.16 19.66 13.58 19.98C12 20.29 10.37 20.13 8.88 19.52C7.39 18.9 6.12 17.86 5.23 16.52C4.34 15.18 3.86 13.61 3.86 12C3.86 9.84 4.72 7.77 6.24 6.25C7.77 4.72 9.84 3.87 11.99 3.87C13.6 3.87 15.17 4.35 16.51 5.24C17.85 6.13 18.89 7.41 19.51 8.89C20.13 10.38 20.29 12.01 19.97 13.59C19.66 15.17 18.88 16.62 17.74 17.76L17.75 17.75Z",
    fill: "#66CFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.28 5.07C10.54 4.99 8.84 5.56 7.5 6.68L10.1 9.28C10.02 9.65 9.89 9.99 9.76 10.1C9.67 10.17 9.6 10.26 9.52 10.35L6.68 7.51C5.49 8.92 4.9 10.75 5.06 12.59C5.21 14.43 6.09 16.14 7.5 17.33C8.76 18.39 10.35 18.98 12 18.98C13.65 18.98 15.24 18.4 16.5 17.33L14.91 15.74V14.1L17.33 16.52C18.44 15.18 19.02 13.48 18.94 11.74C18.86 10 18.13 8.36 16.9 7.13C15.67 5.9 14.02 5.17 12.29 5.09L12.28 5.07ZM14.65 16.02C14.65 16.63 14.19 17.12 13.62 17.12H10.38C9.81 17.12 9.34 16.63 9.34 16.02V11.51C9.34 11.03 9.55 10.58 9.9 10.29C10.25 10 10.44 8.92 10.44 8.46V7.25C10.44 7.05 10.6 6.88 10.81 6.88H13.16C13.37 6.88 13.54 7.05 13.54 7.26V8.46C13.54 8.92 13.74 10.01 14.08 10.29C14.43 10.58 14.64 11.03 14.64 11.51V16.02H14.65Z",
    fill: "#66CFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipLactoseFree);
export default __webpack_public_path__ + "static/media/ic-chip-lactose-free.37c0ef5b770ab07901cf7468466b5ea1.svg";
export { ForwardRef as ReactComponent };